export const getScanRequestFileUrl = (requestId: string, downloadable?: boolean) => {
  const isDownloadable = downloadable ? '?download=true' : '';
  return `${process.env.REACT_APP_API_URL}/portal-api/v1/archive/scan-requests/${requestId}/file${isDownloadable}`;
};
